import React from "react";
import styled from "styled-components";

import { dataCurators } from "./dataCurators";

const ProjectCurator = styled.div`
  margin: 67px 0 0 0;
  display: flex;

  &:not(:first-child) {
    margin-top: 60px;
  }

  @media screen and (max-width: 568px) {
    flex-direction: column;
    margin-top: 50px;

    &:not(:first-child) {
      margin-top: 45px;
    }
  }
`;

const AboutCurator = styled.div`
  margin-right: 43px;

  & > div p {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-size: 15px;
    line-height: 21px;

    color: #000000;

    &:first-child {
      font-weight: bold;
      color: #16283f;
    }

    &:last-child {
      font-weight: 300;
    }

    @media screen and (max-width: 568px) {
      text-align: left;
      font-size: 16px;
    }
  }

  @media screen and (max-width: 568px) {
    margin: 0 0 15px 0;
  }

  img {
    width: 210px;
    height: 210px;
    margin: 0 auto 21px auto;
    display: block;

    @media screen and (max-width: 568px) {
      width: 280px;
      height: 280px;
    }
  }
`;

const GreetingFrom = styled.div`
  & p {
    line-height: 25px;
    font-size: 15px;
    color: #444444;

    &:not(:last-child) {
      margin-bottom: 21px;
    }

    @media screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

const FrameContainer = styled.div`
  & {
    margin-top: 40px;

    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

const Container = styled.section`
  max-width: 800px;
  margin: 0 auto;
  padding-top: 40px;

  @media (max-width: 820px) {
    padding: 0 20px;
  }

  @media (max-width: 568px) {
    padding-top: 20px;
  }

  & p {
    font-family: Merriweather, sans-serif;
    font-style: normal;

    color: #000000;
  }

  & > p:nth-child(1) {
    font-weight: 300;
    font-size: 15px;
    line-height: 25px;

    color: #000000;
  }
`;

const Curators = () => {
  return (
    <Container>
      <p>
        На этом сайте собрано более 75 000 имен исторических деятелей XV-XX
        веков, которые встречаются на страницах дореволюционных журналов
        «Русская старина», «Русский архив» и «Исторический вестник». Каждая
        персональная карточка снабжена интерактивными адресными ссылками на
        упоминания персоны в журнале: вы можете моментально перейти к полному
        тексту интересующей вас статьи, а также принять участие в проверке и
        редактуре карточек. Постепенно мы будем пополнять указатель другими
        дореволюционными изданиями по истории России.
      </p>
      <FrameContainer>
        <iframe
          title="Имена"
          src="https://www.youtube.com/embed/pyYTeOSu52Y?rel=0&autoplay=1&iv_load_policy=3"
          frameBorder="0"
          allowFullScreen
        />
      </FrameContainer>
      {dataCurators.map((data, i) => {
        return (
          <ProjectCurator key={i}>
            <AboutCurator>
              <img src={data.img} alt="" />
              <div>
                {data.about.map((text, i) => {
                  return <p key={i}>{text}</p>;
                })}
              </div>
            </AboutCurator>
            <GreetingFrom>
              {data.greeting.map((text, i) => {
                return <p key={i}>{text}</p>;
              })}
            </GreetingFrom>
          </ProjectCurator>
        );
      })}
    </Container>
  );
};

export default Curators;



// WEBPACK FOOTER //
// ./src/components/Curators/index.js